import React from 'react';

const FastApiIcon = ({ fillColor, width = "55", height = "55", ...props }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 300.000000 300.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g
      transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
      fill={fillColor}
      stroke="none"
    >
      <path
        d="M1458 2995 c-4 -4 -35 -9 -70 -12 -35 -2 -81 -6 -103 -9 -22 -3 -49
-6 -61 -8 -11 -1 -24 -5 -30 -8 -9 -5 -78 -21 -99 -23 -5 0 -14 -3 -20 -6 -11
-7 -80 -30 -98 -33 -7 -1 -22 -8 -34 -14 -13 -7 -23 -9 -23 -5 0 4 -4 4 -8 -2
-4 -5 -42 -27 -84 -48 -43 -22 -105 -56 -138 -78 -33 -21 -62 -39 -64 -40 -26
-5 -339 -317 -334 -332 1 -1 -17 -30 -40 -65 -22 -34 -57 -97 -79 -140 -21
-42 -42 -80 -48 -84 -5 -4 -6 -8 -2 -8 4 0 2 -10 -5 -22 -7 -13 -13 -25 -13
-28 -3 -23 -29 -102 -36 -106 -4 -2 -6 -11 -2 -19 3 -8 0 -15 -6 -15 -6 0 -8
-6 -5 -14 3 -8 1 -17 -5 -20 -6 -4 -8 -13 -4 -21 3 -9 0 -21 -6 -29 -6 -7 -8
-16 -5 -19 4 -3 3 -14 -1 -24 -5 -10 -9 -31 -11 -48 -1 -16 -5 -61 -9 -100 -9
-88 -9 -142 0 -230 4 -38 8 -83 9 -100 2 -16 6 -38 10 -47 4 -9 5 -21 2 -27
-4 -5 -2 -13 4 -16 6 -4 8 -15 5 -26 -4 -11 -2 -19 5 -19 7 0 10 -8 7 -20 -3
-11 -1 -20 5 -20 6 0 8 -7 5 -15 -4 -8 -2 -17 2 -19 9 -6 37 -98 32 -105 -1
-2 2 -7 7 -10 6 -3 12 -15 14 -26 1 -11 5 -22 8 -25 5 -5 72 -142 73 -150 1
-3 9 -14 19 -24 9 -10 15 -23 12 -28 -3 -4 -1 -8 4 -8 5 0 15 -12 23 -27 8
-15 26 -40 42 -57 15 -17 27 -33 27 -37 0 -7 145 -164 169 -183 7 -6 27 -23
43 -38 16 -16 33 -28 37 -28 3 0 21 -13 38 -29 18 -16 34 -26 37 -23 3 2 8 -3
12 -12 3 -9 10 -13 15 -10 5 3 12 -2 15 -10 3 -9 9 -14 14 -11 4 2 17 -5 28
-16 12 -10 23 -18 24 -17 5 5 123 -56 126 -65 2 -4 8 -5 13 -1 5 3 9 1 9 -3 0
-5 10 -9 22 -10 11 -1 25 -8 29 -15 5 -7 9 -9 9 -4 0 5 7 3 15 -4 8 -7 15 -9
15 -5 0 4 7 2 15 -5 8 -7 15 -9 15 -5 0 4 7 2 15 -5 8 -7 15 -9 15 -5 0 4 6 2
13 -4 8 -6 17 -8 20 -4 4 3 13 1 20 -5 8 -7 17 -9 20 -6 3 3 12 2 19 -2 12 -8
38 -13 68 -15 8 0 22 -3 30 -6 27 -11 72 -13 250 -13 188 1 225 3 253 15 10 4
21 5 24 1 3 -3 12 -1 19 5 8 6 20 9 29 6 8 -4 17 -2 20 4 4 5 12 9 18 8 7 -1
25 3 40 9 16 7 32 10 37 7 5 -3 11 -1 15 5 4 6 10 8 15 5 5 -3 11 -1 15 5 4 6
11 8 16 5 5 -4 9 -2 9 3 0 8 71 34 86 32 4 -1 10 2 13 7 7 11 97 55 107 53 4
-1 10 2 13 7 8 11 91 65 91 59 0 -3 12 6 26 19 15 14 33 25 40 25 8 0 14 4 14
8 0 5 22 26 50 48 63 49 137 123 192 191 23 29 45 53 50 53 4 0 8 6 8 14 0 7
11 25 25 40 13 14 22 26 19 26 -6 0 48 83 59 91 5 3 8 9 7 13 -2 10 42 100 53
107 5 3 8 8 7 10 -4 10 13 59 21 59 5 0 6 7 3 15 -4 8 -1 15 6 15 6 0 9 4 5 9
-3 5 -1 12 5 16 6 4 8 10 5 15 -3 5 -1 11 4 15 6 3 8 12 4 20 -3 8 0 15 6 15
6 0 8 6 5 14 -3 8 -1 17 5 20 6 4 8 13 5 20 -3 8 -1 17 5 20 6 4 8 13 4 21 -3
9 0 21 6 29 6 7 8 16 5 19 -4 3 -3 14 1 24 13 28 15 66 15 253 0 186 -2 225
-14 252 -4 9 -5 22 -1 28 4 6 1 17 -5 25 -6 8 -9 19 -6 24 4 5 1 13 -5 16 -5
4 -8 13 -5 21 3 7 1 16 -5 20 -6 3 -8 12 -5 19 2 7 -1 18 -7 24 -6 6 -7 11 -3
11 5 0 3 7 -4 15 -7 8 -9 15 -5 15 4 0 2 7 -5 15 -7 8 -9 15 -5 15 4 0 2 7 -5
15 -7 8 -9 15 -4 15 5 0 3 4 -4 9 -7 4 -14 18 -15 29 -1 12 -5 22 -10 22 -4 0
-6 4 -3 9 4 5 3 11 -1 13 -9 3 -63 109 -63 121 0 4 -9 17 -19 29 -11 11 -18
24 -16 28 3 5 -2 11 -11 14 -8 3 -13 10 -10 15 3 5 -1 12 -10 15 -9 4 -14 9
-12 12 3 3 -7 19 -23 37 -16 17 -29 35 -29 39 0 15 -233 248 -249 248 -3 0
-20 12 -37 28 -17 15 -42 33 -57 41 -15 8 -27 18 -27 23 0 5 -4 7 -8 4 -5 -3
-19 4 -30 15 -12 10 -24 19 -27 19 -6 0 -138 63 -145 70 -3 3 -14 7 -25 8 -11
2 -23 9 -27 15 -4 7 -8 9 -8 5 0 -6 -51 8 -100 28 -8 4 -28 8 -44 10 -16 2
-34 9 -41 14 -7 5 -15 7 -18 4 -3 -3 -11 -2 -18 2 -7 4 -22 9 -33 10 -12 2
-39 5 -61 8 -22 3 -60 7 -85 9 -25 2 -72 7 -105 11 -33 5 -63 5 -67 1z m94
-823 l-37 -442 338 0 c198 0 337 -4 335 -9 -16 -44 -754 -1361 -756 -1350 -1
8 13 204 33 435 19 231 35 430 35 442 l0 22 -336 0 c-300 0 -336 2 -330 16 5
12 720 1309 744 1349 13 21 10 -33 -26 -463z"
      />
    </g>
  </svg>
);

export default FastApiIcon;